import {ActionHandler} from "../../../infrastructure/handlers/action-handler";
import {CalendarClickEvent} from "../../../core/models/events/calendar-click-event";
import {AnalyticsService} from "../../../third-party-services/analytics/analytics-service";
import {SCORES_HEADER_MODULE} from "../scores-list-header-module.consts";
import {contractsUtils} from "../../../infrastructure/utils/contracts-utils";
import {DatetimeUtils} from "../../../infrastructure/utils/datetime-utils";
import {ScoresListHeaderModuleState} from "../models/scores-list-header-module.state";
import {ScoresListHeaderModuleController} from "../scores-list-header-module.controller";

export class ScoresListHeaderModuleDateChangedEventHandler extends ActionHandler {
  type = SCORES_HEADER_MODULE.ACTION_HANDLERS.dateChange;
  controller: ScoresListHeaderModuleController;
  state: ScoresListHeaderModuleState;
  datetimeUtils: DatetimeUtils;

  static injectables = [...ActionHandler.injectables, AnalyticsService, DatetimeUtils];

  constructor(service: AnalyticsService, datetimeUtils: DatetimeUtils) {
    super();

    contractsUtils.requiredType(service, AnalyticsService);
    contractsUtils.requiredType(datetimeUtils, DatetimeUtils);

    this.datetimeUtils = datetimeUtils;
    this.service = service;
  }

  async action(params) {
    const event: CalendarClickEvent = new CalendarClickEvent(params);

    this.service.createEvent(event);
  }
}
